<div
	class="ada-inline-menu-bar"
	role="list"
>
	@for (item of items(); track item.id) {
		@let iconConfig = item.icon | async;
		<div [title]="item.description || item.name || ''">
			<button
				class="ada-btn ada-btn-small ada-inline-menu-action-item"
				data-testid="inline-menu-action-button"
				role="listitem"
				type="button"
				[attr.aria-label]="item.name || 'action-item'"
				[class.ada-is-disabled]="isDisabled || (item.isDisabled | async) || (isLoading | async) || null"
				[class.icon-only]="!item.name"
				[style.color]="color()"
				(click)="select($event, item)"
			>
				@if (iconConfig?.icon) {
					<ada-icon
						aria-hidden="true"
						class="ada-inline-menu-item-icon"
						[icon]="iconConfig.icon"
					/>
				}
				@if (item.name) {
					<span class="ada-inline-menu-item-label">{{ item.name }}</span>
				}
			</button>
		</div>
	} @empty {
		<span class="ada-inline-menu-empty-state">No actions available</span>
	}
</div>
